import {Component, EventEmitter, Input, Output} from '@angular/core';

import {PreloaderComponent} from "../../../../../shared/ui/preloader/preloader.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LoadingService} from "../../../../../shared/services/loading.service";
import {EducationService} from "../../../../../shared/services/education.service";
import {tap} from "rxjs";
import {IframeModalComponent} from "../../../../../shared/ui/iframe-modal/iframe-modal.component";
import {IframeValidatorPipe} from "../../../../../shared/pipes/iframe-validator.pipe";
import {IframeWrapperComponent} from "../../../../../shared/ui/iframe-wrapper/iframe-wrapper.component";

@Component({
    selector: 'app-lesson-content-item-iframe',
    standalone: true,
    imports: [
    PreloaderComponent,
    ReactiveFormsModule,
    IframeModalComponent,
    FormsModule,
    IframeValidatorPipe,
    IframeWrapperComponent
],
    templateUrl: './lesson-content-item-iframe.component.html',
    styleUrl: './lesson-content-item-iframe.component.scss'
})
export class LessonContentItemIframeComponent {
  @Input() EditMode = false;
  @Input() IsSelected = false;

  @Output() OnChangedFile = new EventEmitter<any>();

  @Input() ItemUid: string = '';
  @Input() ItemType: string = '';
  @Input() ItemData: any = '';
  isLoading = true;
  @Output() OnChanged = new EventEmitter<unknown>();

  InitText: any = null;

  showIframe = false;


  constructor(
    public loadingService: LoadingService,
    private educationService: EducationService,
  ) {}

  get hasChanged() { return this.InitText != this.ItemData };


  ngOnInit(): void {
    this.isLoading = false;
    this.InitText = this.ItemData;
  }

  changeText() {
    this.ChangeItem().subscribe()
  }

  cancelChangeText () {
    this.ItemData = this.InitText;
    this.OnChanged.emit(this.ItemData)
  }

  ChangeItem() {
    const form = new FormData();
    form.append('content', String(this.ItemData));
    return this.educationService.EditLessonContentData(this.ItemUid, form)
      .pipe(
        tap((res) => {
          this.InitText = this.ItemData;
          this.OnChanged.emit(this.ItemData)
        })
      )
  }

  openIframe() {
    //this.iframeUrl = url;
    this.showIframe = true;
  }

  closeIframe() {
    console.log("closeIframe")
    this.showIframe = false;
    //this.iframeUrl = '';
  }







}
